import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  format_date,
  GET,
  PUT,
  UPLOAD,
  t,
  can,
} from "../../components/CustomComponent.js";
import {
  EMPTY_GROUP,
  BANNER_THEMES,
  ADMIN_ICON,
  clone,
  ordered,
  moveItem,
  nextSort,
  newUid,
  hasBannerText,
  bannerLabel,
} from "../../components/homepage_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_type.css";
import "../../assets/css/home_manage.css";
import "../../assets/css/homepage.css";

/* ============================================================================
 * จัดการหน้าแรก › แบนเนอร์โครงการ  (/ad/home/banners)
 *
 * แถบโปรโมตโครงการใต้กล่องค้นหาของหน้าเว็บลูกค้า เป็นสไลด์เปลี่ยนไปทีละใบ
 * ที่นี่คุมข้อความทุกบรรทัด รูปพื้นหลัง สีพื้นหลัง ลำดับ และเปิด-ปิดทีละใบ
 * กล่องพรีวิวใช้โครงและ CSS ชุดเดียวกับหน้าเว็บจริง (.hm-banner) จึงเห็นผลตรงกัน
 *
 * รูปพื้นหลังไม่บังคับ ไม่ใส่ก็ใช้สีจาก theme อย่างเดียวเหมือนเดิม ใส่แล้วรูปขึ้นเต็มใบ
 * ตามที่ออกแบบมา ไม่มีฉากมืดคลุมให้ เว้นแต่จะเปิด "ฉากมืดคลุมรูป" เอง — เปิดเมื่อจะพิมพ์
 * ข้อความสีขาวทับรูปที่สว่างจนตัวอักษรจม
 *
 * กรอบแบนเนอร์ยึดสัดส่วนไฟล์ภาพจริงของใบนั้น (มาตรฐาน 1920 x 830 ตอนยังไม่มีรูป)
 * ถ้าอัปโหลดรูปที่มีข้อความอยู่ในไฟล์อยู่แล้ว ก็ปล่อยช่องข้อความว่างไว้ทั้งหมดได้ —
 * ใบนั้นจะขึ้นเป็นรูปล้วนตามสัดส่วนจริงของไฟล์ ไม่มีตัวอักษรหรือฉากมืดมาทับ
 * ช่องไหนไม่ได้กรอก บรรทัดนั้นก็ไม่ขึ้นบนแบนเนอร์ ไม่มีข้อความสำรองมาเติมให้
 *
 * ข้อมูลอ่าน/บันทึกผ่าน API จริง
 *   GET  admin/homepage/banner
 *   PUT  admin/homepage/banner   (ส่ง { items })
 * บันทึกแบบแทนที่ทั้งชุด — จัดลำดับ/เปิด-ปิดในหน้าจอจนพอใจแล้วค่อยกดบันทึกครั้งเดียว
 * ========================================================================== */

const EMPTY_FORM = {
  src: "",
  veil: false, // ฉากมืดคลุมรูป — ปิดไว้ก่อน รูปแบนเนอร์ส่วนใหญ่ตั้งใจให้เห็นสีจริง

  kicker: "",
  title: "",
  sub: "",
  brand: "",
  brand_sub: "",
  headline: "",
  detail: "",
  price: "",
  price_unit: "ล้านบาท*",
  theme: BANNER_THEMES[0].value,
  is_active: true,
};

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

export default class HomeBannerSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: clone(EMPTY_GROUP.banner.items),
      saved: clone(EMPTY_GROUP.banner.items),

      preview: 0,
      ratios: {}, // สัดส่วนจริงของไฟล์รูปแต่ละใบ (อ่านตอนรูปโหลดเสร็จ) — ใช้กับใบรูปล้วน
      /* ย่อรายการเพื่อดูตัวอย่างหน้าเว็บเต็มความกว้าง — พรีวิวคอลัมน์แคบเห็นแค่พอเดาได้
         ย่อแล้วกล่องพรีวิวจะกางเต็มแถวและวางเนื้อหาแบบเดียวกับหน้าเว็บจริงเป๊ะ */
      list_open: true,
      modal_form: false,
      edit_uid: "",
      form: { ...EMPTY_FORM },
      updated_at: "",
      updated_by: "",
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
    // พรีวิวเลื่อนเองเหมือนหน้าเว็บจริง (6 วินาทีต่อใบ)
    this.timer = setInterval(() => {
      const total = this.activeItems().length;
      if (total > 1) this.setState((prev) => ({ preview: (prev.preview + 1) % total }));
    }, 6000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  /* โหลดเนื้อหากลุ่มนี้จากฐานข้อมูล — เรียกทั้งตอนเปิดหน้าและหลังบันทึกสำเร็จ
     เพื่อให้ uid ของรายการที่เพิ่งสร้างตรงกับฝั่ง server */
  Get = async () => {
    loading(true);
    const result = await GET("admin/homepage/banner", {});
    loading(false);
    if (result?.status && result.data) this.Apply(result.data);
  };

  Apply = (data) =>
    this.setState({
      items: data.items || [],
      saved: clone(data.items || []),
      updated_at: data.updated_at || "",
      updated_by: data.updated_by || "",
    });

  activeItems = () => ordered(this.state.items).filter((item) => item.is_active);

  isDirty = () => JSON.stringify(this.state.items) !== JSON.stringify(this.state.saved);

  ToggleList = () => this.setState((prev) => ({ list_open: !prev.list_open }));

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* ใบรูปล้วนต้องสูงตามสัดส่วนจริงของไฟล์ เหมือนที่หน้าเว็บฝั่งลูกค้าทำ
     เก็บต่อ key (uid ของใบ หรือ URL รูปในฟอร์ม) ครั้งเดียวพอ */
  keepRatio = (key, event) => {
    const { naturalWidth: width, naturalHeight: height } = event.target;
    if (!width || !height) return;
    this.setState((prev) => (prev.ratios[key] ? null : { ratios: { ...prev.ratios, [key]: width / height } }));
  };

  /* ---------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ */
  OpenCreate = () => this.setState({ modal_form: true, edit_uid: "", form: { ...EMPTY_FORM } });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      form: {
        src: item.src || "",
        veil: !!item.veil,
        kicker: item.kicker || "",
        title: item.title || "",
        sub: item.sub || "",
        brand: item.brand || "",
        brand_sub: item.brand_sub || "",
        headline: item.headline || "",
        detail: item.detail || "",
        price: item.price || "",
        price_unit: item.price_unit || t("home_banner_unit"),
        theme: item.theme || BANNER_THEMES[0].value,
        is_active: !!item.is_active,
      },
    });

  CloseForm = () => this.setState({ modal_form: false });

  /* อัปโหลดขึ้น storage ทันทีแล้วเก็บเป็น URL — ไม่เก็บ base64 ลงฐานข้อมูล
     เพราะรูปหนึ่งใบกินหลายเมกะไบต์ และทำให้ payload ตอนบันทึกใหญ่เกินจำเป็น */
  PickImage = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = ""; // เลือกไฟล์เดิมซ้ำได้
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return alert("", "warning", t("warning"), t("home_verify_image_size"));

    loading(true);
    const result = await UPLOAD(file, { folder: "homepage/banner" });
    loading(false);

    if (!result?.status || !result.data?.file_path) {
      return alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    this.setForm({ src: result.data.file_path });
  };

  SaveBanner = () => {
    const { form, edit_uid } = this.state;
    /* มีรูปแล้วปล่อยช่องข้อความว่างได้ทั้งหมด — ไฟล์ภาพแบนเนอร์มีข้อความในตัวอยู่แล้ว
       ถ้าไม่มีรูป ต้องมีชื่อโครงการกับจุดขาย ไม่งั้นจะได้แบนเนอร์เปล่า ๆ */
    if (!form.src.trim()) {
      if (!form.brand.trim()) return alert("", "warning", t("warning"), t("home_verify_brand"));
      if (!form.headline.trim()) return alert("", "warning", t("warning"), t("home_verify_headline"));
    }

    const payload = {
      src: form.src,
      veil: !!form.veil,
      kicker: form.kicker.trim(),
      title: form.title.trim(),
      sub: form.sub.trim(),
      brand: form.brand.trim(),
      brand_sub: form.brand_sub.trim(),
      headline: form.headline.trim(),
      detail: form.detail.trim(),
      price: form.price.trim(),
      // ไม่ได้กรอกราคา = ไม่มีบรรทัดราคาบนแบนเนอร์ หน่วยจึงไม่ต้องเก็บไว้ให้ค้าง
      price_unit: form.price.trim() ? form.price_unit.trim() || t("home_banner_unit") : "",
      theme: form.theme,
      is_active: form.is_active,
      cta: "home_banner_cta",
    };

    this.setState((prev) => ({
      items: edit_uid
        ? prev.items.map((row) => (row.uid === edit_uid ? { ...row, ...payload } : row))
        : [...prev.items, { ...payload, uid: newUid("bn"), id: newUid("bn"), sort: nextSort(prev.items) }],
      modal_form: false,
      preview: 0,
    }));
  };

  Move = (item, step) => this.setState((prev) => ({ items: moveItem(prev.items, item.uid, step), preview: 0 }));

  ToggleActive = (item) =>
    this.setState((prev) => ({
      items: prev.items.map((row) => (row.uid === item.uid ? { ...row, is_active: !row.is_active } : row)),
      preview: 0,
    }));

  Delete = async (item) => {
    // ใบรูปล้วนไม่มีข้อความให้เอ่ยชื่อ จึงบอกแค่ลำดับที่ของใบนั้นแทน
    const label = bannerLabel(item) || `${t("home_unit_banner")} ${ordered(this.state.items).findIndex((row) => row.uid === item.uid) + 1}`;
    if (!(await alert("", "warning", t("delete_item"), `${t("home_delete_banner_desc")}\n${label}`, t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ items: prev.items.filter((row) => row.uid !== item.uid), preview: 0 }));
  };

  Save = async () => {
    if (!this.state.items.some((item) => item.is_active)) return alert("", "warning", t("warning"), t("home_verify_banner_active"));
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/homepage/banner", { items: this.state.items });
    loading(false);
    if (!result?.status) return;

    this.Apply(result.data);
    alert("", "success", t("success"), t("home_save_done"));
  };

  Reset = async () => {
    if (!this.isDirty()) return;
    if (!(await alert("", "warning", t("reset_changes"), t("discard_changes_confirm"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ items: clone(prev.saved), preview: 0 }));
  };

  /* ================================================== render : รายการแบนเนอร์ */
  renderList = () => {
    const list = ordered(this.state.items);
    const active = list.filter((item) => item.is_active).length;
    const dirty = this.isDirty();

    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_banner_list_title")}
          </span>
          <div className="hmg-sum">
            <span className="ppl-pill ppl-pill--ghost">
              {list.length} {t("home_unit_banner")}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {active} {t("active")}
            </span>
            {can("homepage.update") && (
              <button type="button" className="prop-btn prop-btn--ghost" onClick={this.OpenCreate}>
                <span className="icon text-12">{ADMIN_ICON.plus}</span>
                {t("home_add_banner")}
              </button>
            )}
            {/* ปุ่มย่อ เป็นแค่มุมมอง ไม่ใช่การแก้ข้อมูล คนที่ดูอย่างเดียวก็กดได้ */}
            <button type="button" className="prop-btn prop-btn--ghost" title={t("home_collapse_hint")} onClick={this.ToggleList}>
              <span className="icon text-12">{ADMIN_ICON.chevron_left}</span>
              {t("collapse")}
            </button>
          </div>
        </div>

        <div className="hmg-list">
          {list.map((item, index) => (
            <div className={`hmg-row ${item.is_active ? "" : "is-off"}`} key={item.uid}>
              <div className="d-flex align-items-center gap-2">
                <span className="pty-rank">{index + 1}</span>
                <div className="pty-order">
                  <button type="button" className="pty-order__btn icon" title={t("ptype_move_up")} disabled={index === 0} onClick={() => this.Move(item, -1)}>
                    {ADMIN_ICON.up}
                  </button>
                  <button
                    type="button"
                    className="pty-order__btn icon"
                    title={t("ptype_move_down")}
                    disabled={index === list.length - 1}
                    onClick={() => this.Move(item, 1)}
                  >
                    {ADMIN_ICON.down}
                  </button>
                </div>
              </div>

              {/* มีรูปพื้นหลังก็โชว์รูป ไม่มีก็โชว์สีพื้นหลังที่เลือกไว้เหมือนเดิม
                  ฉากมืดคลุมตามที่ใบนั้นเลือกไว้ จะได้เห็นสีจริงเหมือนบนหน้าเว็บ */}
              <div className="hmg-swatch" style={{ background: item.theme }}>
                {!!item.src && (
                  <>
                    <img className="hmg-swatch__img" src={item.src} alt={bannerLabel(item)} />
                    {!!item.veil && <span className="hmg-swatch__veil" />}
                  </>
                )}
                {!!item.brand && <span className="hmg-swatch__brand">{item.brand}</span>}
                {!!item.brand_sub && <span className="hmg-swatch__sub">{item.brand_sub}</span>}
              </div>

              {/* ช่องไหนไม่ได้กรอกก็ไม่ต้องมีบรรทัด/ชิปเปล่ามาคั่น */}
              <div className="hmg-row__body">
                {!!item.headline && (
                  <div className="hmg-row__title">
                    <span>{item.headline}</span>
                  </div>
                )}
                {!!item.detail && <div className="hmg-row__desc">{item.detail}</div>}
                {!hasBannerText(item) && <div className="hmg-row__desc">{t("home_banner_image_only")}</div>}
                {!!(item.kicker || item.price) && (
                  <div className="hmg-row__meta">
                    {!!item.kicker && <span className="hmg-tag">{item.kicker}</span>}
                    {!!item.price && (
                      <span className="hmg-tag hmg-tag--lime">
                        {t("home_banner_start")} {item.price} {item.price_unit || t("home_banner_unit")}
                      </span>
                    )}
                  </div>
                )}
              </div>

              {/* เปิด/ปิด แก้ไข ลบ : ต้องมีสิทธิ์แก้ไขหน้าแรก */}
              {can("homepage.update") && (
                <div className="hmg-row__actions">
                  <label className="ppl-switch" title={item.is_active ? t("home_hide") : t("home_show")}>
                    <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
                    <span className="ppl-switch__track" />
                  </label>
                  <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                    {ADMIN_ICON.edit}
                  </button>
                  <button
                    type="button"
                    className="prop-iconbtn icon"
                    style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                    title={t("delete")}
                    onClick={() => this.Delete(item)}
                  >
                    {ADMIN_ICON.trash}
                  </button>
                </div>
              )}
            </div>
          ))}

          {!list.length && (
            <div className="hmg-empty">
              <span className="icon">{ADMIN_ICON.grid}</span>
              {t("home_empty_banner")}
            </div>
          )}
        </div>

        {/* ไม่มีสิทธิ์แก้ = ไม่ต้องมีแถบบันทึก ดูอย่างเดียว */}
        {can("homepage.update") && (
          <div className="ppl-savebar">
            {dirty ? (
              <span className="ppl-dirty">
                <span className="ppl-dirty__dot" />
                {t("unsaved_changes")}
              </span>
            ) : (
              <span className="text-secondary text-12 d-flex align-items-center gap-2">
                <span className="icon">{ADMIN_ICON.check}</span>
                {t("all_changes_saved")}
              </span>
            )}
            <div className="d-flex gap-2">
              <button type="button" className="prop-btn prop-btn--ghost" disabled={!dirty} onClick={this.Reset}>
                <span className="icon text-12">{ADMIN_ICON.reset}</span>
                {t("reset_changes")}
              </button>
              <button type="button" className="prop-btn" disabled={!dirty} onClick={this.Save}>
                <span className="icon text-12">{ADMIN_ICON.save}</span>
                {t("save_settings")}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* ======================================== render : แถบแคบตอนย่อรายการ */
  /* ย่อแล้วการ์ดรายการทั้งใบถูกแทนด้วยแถบนี้ ที่ว่างที่เหลือยกให้ตัวอย่างเว็บฝั่งขวา
     ยังมีของค้างไม่ได้บันทึกก็กดบันทึกจากตรงนี้ได้เลย ไม่ต้องขยายกลับก่อน */
  renderRail = () => {
    const list = ordered(this.state.items);
    const dirty = this.isDirty();

    return (
      <div className="prop-card prop-in hmg-rail">
        <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("expand")} onClick={this.ToggleList}>
          {ADMIN_ICON.chevron_right}
        </button>
        <span className="hmg-rail__label">{t("home_banner_list_title")}</span>
        <span className="hmg-rail__count">
          {list.length} {t("home_unit_banner")}
        </span>
        {dirty && can("homepage.update") && (
          <button type="button" className="prop-iconbtn icon hmg-rail__save" title={t("unsaved_changes")} onClick={this.Save}>
            {ADMIN_ICON.save}
          </button>
        )}
      </div>
    );
  };

  /* ==================================================== render : กล่องพรีวิว */
  /* ใช้ markup + CSS ชุดเดียวกับหน้าเว็บจริง (ครอบด้วย .mn-home) จะได้เห็นของจริง */
  renderPreview = () => {
    const list = this.activeItems();
    const index = list.length ? this.state.preview % list.length : 0;
    /* กรอบยึดสัดส่วนจริงของไฟล์ที่กำลังโชว์เหมือนหน้าเว็บจริง (มาตรฐาน 1920 x 830
       ตอนยังไม่มีรูป) ใบรูปล้วนไม่ต้องเว้นระยะขอบและไม่ต้องคุมความสูงขั้นต่ำ */
    const current = list[index];
    const media = !!current && !!current.src && !hasBannerText(current);
    const ratio = current?.src ? this.state.ratios[current.uid] : 0;

    /* ย่อรายการแล้ว = กล่องพรีวิวกางเต็มแถว กว้างพอจะวางเนื้อหาแบบเดียวกับหน้าเว็บจริง
       (ซ้าย-กลาง-ขวาเรียงแนวนอน ตัวอักษรขนาดจริง) ไม่ต้องบีบเป็นแนวตั้งเหมือนคอลัมน์แคบ */
    const wide = !this.state.list_open;

    return (
      <div className="prop-card prop-in hmg-preview">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_preview")}
          </span>
          <a className="prop-link" href="/" target="_blank" rel="noreferrer">
            <span className="icon text-12">{ADMIN_ICON.external}</span>
            {t("home_open_site")}
          </a>
        </div>

        <div className="p-3">
          <div className="hmg-frame">
            <div className="hmg-frame__bar">
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__url">safespacelifeliving.com</span>
            </div>
            <div className="hmg-frame__body">
              <div className="mn-home">
                <div
                  className={`hm-banner ${media ? "hm-banner--media" : ""}`}
                  style={{ ...(media || wide ? {} : { minHeight: "240px" }), ...(ratio ? { "--hm-banner-ratio": ratio } : {}) }}
                >
                  {list.map((item, i) => {
                    const text = hasBannerText(item);
                    const left = !!(item.kicker || item.title || item.sub);

                    /* คอลัมน์แคบต้องบีบเป็นแนวตั้งและย่อตัวอักษร ส่วนโหมดเต็มความกว้าง
                       ปล่อยให้ CSS ของหน้าเว็บจริงจัดให้ทั้งหมด จะได้เห็นของจริงเป๊ะ */
                    const slideStyle = wide
                      ? { background: item.theme, ...(text ? {} : { padding: 0 }) }
                      : { background: item.theme, flexDirection: "column", alignItems: "flex-start", gap: "8px", padding: text ? "20px 24px" : 0 };

                    return (
                      <div key={item.uid} className={`hm-banner__slide ${i === index ? "is-active" : ""}`} style={slideStyle}>
                        {!!item.src && (
                          <>
                            <img
                              className="hm-banner__bg"
                              src={item.src}
                              alt=""
                              aria-hidden="true"
                              onLoad={(e) => this.keepRatio(item.uid, e)}
                              ref={(el) => el?.complete && this.keepRatio(item.uid, { target: el })}
                            />
                            {!!item.veil && <span className="hm-banner__veil" />}
                          </>
                        )}

                        {left && (
                          <div className="hm-banner__left">
                            {!!item.kicker && <div className="hm-banner__kicker">{item.kicker}</div>}
                            {!!(item.title || item.sub) && (
                              <div className="hm-banner__title" style={wide ? undefined : { fontSize: "20px" }}>
                                {item.title}
                                {!!item.sub && <small>{item.sub}</small>}
                              </div>
                            )}
                            {/* ชิป CTA กับชื่อแบรนด์กินที่ คอลัมน์แคบเลยตัดออก เต็มความกว้างค่อยโชว์ครบ */}
                            {wide && !!item.cta && (
                              <span className="hm-banner__tag">
                                <span className="icon">{ADMIN_ICON.star}</span>
                                {t(item.cta)}
                              </span>
                            )}
                          </div>
                        )}

                        {wide && !!(item.brand || item.brand_sub) && (
                          <div className="hm-banner__mid">
                            <div className="hm-banner__logo">
                              {item.brand}
                              {!!item.brand_sub && <small>{item.brand_sub}</small>}
                            </div>
                          </div>
                        )}

                        {!!(item.headline || item.detail || item.price) && (
                          <div className="hm-banner__right" style={wide ? undefined : { textAlign: "left" }}>
                            {!!item.headline && <p style={wide ? undefined : { fontSize: "14px" }}>{item.headline}</p>}
                            {wide && !!item.detail && <p className="hm-banner__detail">{item.detail}</p>}
                            {!!item.price && (
                              <div className="hm-banner__price">
                                {t("home_banner_start")}
                                <b>{item.price}</b>
                                {item.price_unit || t("home_banner_unit")}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* เลื่อนดูทีละใบด้วยลูกศรที่วางทับรูปชุดเดียวกับหน้าเว็บจริง
                      ไม่มีแถบจุดมาคาดใต้รูป และใบเดียวก็ไม่ต้องมีปุ่มมาบัง */}
                  {list.length > 1 && (
                    <>
                      <button
                        type="button"
                        className="hm-banner__nav is-prev"
                        aria-label="prev"
                        onClick={() => this.setState({ preview: (index - 1 + list.length) % list.length })}
                      >
                        <span className="icon">{ADMIN_ICON.chevron_left}</span>
                      </button>
                      <button
                        type="button"
                        className="hm-banner__nav is-next"
                        aria-label="next"
                        onClick={() => this.setState({ preview: (index + 1) % list.length })}
                      >
                        <span className="icon">{ADMIN_ICON.chevron_right}</span>
                      </button>
                    </>
                  )}

                  {!list.length && <div className="hmg-empty">{t("home_empty_banner")}</div>}
                </div>
              </div>
            </div>
          </div>

          <div className="ppl-note mt-3">
            <span className="icon">{ADMIN_ICON.info}</span>
            <div>{t("home_banner_preview_hint")}</div>
          </div>
        </div>
      </div>
    );
  };

  /* ================================================== render : ฟอร์มเพิ่ม/แก้ */
  renderFormModal = () => {
    const { modal_form, edit_uid, form, ratios } = this.state;
    /* ตัวอย่างในฟอร์มใช้กติกาเดียวกับหน้าเว็บ : ช่องไหนว่างก็ไม่ขึ้นบรรทัดนั้น
       ไม่กรอกสักช่องเลย = ใบรูปล้วน โชว์รูปเต็มตามสัดส่วนไฟล์ ไม่มีอะไรมาทับ */
    const text = hasBannerText(form);
    const media = !!form.src && !text;
    const ratio = form.src ? ratios[`form:${form.src}`] : 0;

    return (
      <Modal show={modal_form} onHide={this.CloseForm} size="lg" centered>
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("home_edit_banner") : t("home_add_banner")}</h5>
            <div className="text-secondary text-12">{t("home_banner_form_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          {/* ตัวอย่างย่อ — เห็นผลทันทีระหว่างพิมพ์ */}
          <div className="mn-home mb-4">
            <div
              className={`hm-banner ${media ? "hm-banner--media" : ""}`}
              style={{ ...(media ? {} : { minHeight: "150px" }), ...(ratio ? { "--hm-banner-ratio": ratio } : {}) }}
            >
              <div className="hm-banner__slide is-active" style={{ background: form.theme, padding: text ? "18px 22px" : 0 }}>
                {!!form.src && (
                  <>
                    <img
                      className="hm-banner__bg"
                      src={form.src}
                      alt=""
                      aria-hidden="true"
                      onLoad={(e) => this.keepRatio(`form:${form.src}`, e)}
                      ref={(el) => el?.complete && this.keepRatio(`form:${form.src}`, { target: el })}
                    />
                    {!!form.veil && <span className="hm-banner__veil" />}
                  </>
                )}
                {!!(form.kicker || form.title || form.sub) && (
                  <div className="hm-banner__left">
                    {!!form.kicker && <div className="hm-banner__kicker">{form.kicker}</div>}
                    {!!(form.title || form.sub) && (
                      <div className="hm-banner__title" style={{ fontSize: "19px" }}>
                        {form.title}
                        {!!form.sub && <small>{form.sub}</small>}
                      </div>
                    )}
                  </div>
                )}
                {!!(form.brand || form.brand_sub) && (
                  <div className="hm-banner__mid">
                    <div className="hm-banner__logo" style={{ fontSize: "24px" }}>
                      {form.brand}
                      {!!form.brand_sub && <small>{form.brand_sub}</small>}
                    </div>
                  </div>
                )}
                {!!(form.headline || form.price) && (
                  <div className="hm-banner__right">
                    {!!form.headline && <p style={{ fontSize: "13px" }}>{form.headline}</p>}
                    {!!form.price && (
                      <div className="hm-banner__price">
                        {t("home_banner_start")}
                        <b>{form.price}</b>
                        {form.price_unit || t("home_banner_unit")}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row g-3">
            {/* รูปพื้นหลัง : อัปโหลดเองหรือปล่อยว่างให้ใช้สีพื้นหลังอย่างเดียว */}
            <div className="col-12">
              <label className="prop-label">{t("home_banner_image")}</label>
              <label className={`hmg-drop hmg-drop--banner ${form.src ? "has-image" : ""}`}>
                <input type="file" accept="image/*" onChange={this.PickImage} />
                {form.src && <img src={form.src} alt="preview" />}
                <span className="hmg-drop__tip">
                  <span className="icon">{ADMIN_ICON.photo}</span>
                  {form.src ? t("change_image") : t("home_pick_image")}
                </span>
              </label>
              <div className="ppl-sub mt-1">{t("home_banner_image_hint")}</div>
              {!!form.src && (
                <button type="button" className="prop-link mt-2" onClick={() => this.setForm({ src: "" })}>
                  <span className="icon text-12">{ADMIN_ICON.trash}</span>
                  {t("home_remove_image")}
                </button>
              )}

              {/* ฉากมืดคลุมรูป : ค่าตั้งต้นคือไม่คลุม เปิดเมื่อจะพิมพ์ข้อความทับรูปที่สว่าง */}
              {!!form.src && (
                <div className="d-flex align-items-center gap-2 mt-3">
                  <label className="ppl-switch">
                    <input type="checkbox" checked={form.veil} onChange={(e) => this.setForm({ veil: e.target.checked })} />
                    <span className="ppl-switch__track" />
                  </label>
                  <div>
                    <div className="text-12 fw-bold text-dark">{t("home_banner_veil")}</div>
                    <div className="ppl-sub">{t("home_banner_veil_hint")}</div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-md-6">
              {/* บังคับเฉพาะใบที่ไม่มีรูป — ใบที่มีรูปแล้วปล่อยว่างได้ทั้งหมด */}
              <label className="prop-label">
                {t("home_banner_brand")} {!form.src && <span className="text-danger">*</span>}
              </label>
              <input type="text" className="prop-field" maxLength={18} placeholder="NUE" value={form.brand} onChange={(e) => this.setForm({ brand: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="prop-label">{t("home_banner_brand_sub")}</label>
              <input
                type="text"
                className="prop-field"
                maxLength={36}
                placeholder="EPIC ASOK - RAMA 9"
                value={form.brand_sub}
                onChange={(e) => this.setForm({ brand_sub: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("home_banner_kicker")}</label>
              <input type="text" className="prop-field" maxLength={30} placeholder="BEYOND LIVING" value={form.kicker} onChange={(e) => this.setForm({ kicker: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="prop-label">{t("home_banner_title")}</label>
              <input type="text" className="prop-field" maxLength={40} placeholder="CRAFTED FOR LIFE" value={form.title} onChange={(e) => this.setForm({ title: e.target.value })} />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_banner_sub")}</label>
              <input type="text" className="prop-field" maxLength={60} value={form.sub} onChange={(e) => this.setForm({ sub: e.target.value })} />
            </div>

            <div className="col-12">
              <label className="prop-label">
                {t("home_banner_headline")} {!form.src && <span className="text-danger">*</span>}
              </label>
              <input type="text" className="prop-field" maxLength={60} value={form.headline} onChange={(e) => this.setForm({ headline: e.target.value })} />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_banner_detail")}</label>
              <input type="text" className="prop-field" maxLength={80} value={form.detail} onChange={(e) => this.setForm({ detail: e.target.value })} />
            </div>

            <div className="col-md-3">
              <label className="prop-label">{t("home_banner_price")}</label>
              <input type="text" className="prop-field" maxLength={12} placeholder="3.29" value={form.price} onChange={(e) => this.setForm({ price: e.target.value })} />
            </div>

            {/* หน่วยราคาพิมพ์เองได้ เช่น ล้านบาท* / บาท/เดือน / บาท/ตร.ว. */}
            <div className="col-md-3">
              <label className="prop-label">{t("home_banner_unit_label")}</label>
              <input
                type="text"
                className="prop-field"
                maxLength={18}
                placeholder={t("home_banner_unit")}
                value={form.price_unit}
                onChange={(e) => this.setForm({ price_unit: e.target.value })}
              />
              <div className="ppl-sub mt-1">{t("home_banner_unit_hint")}</div>
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("status")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                  {form.is_active ? t("home_show") : t("home_hide")}
                </span>
              </div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_banner_theme")}</label>
              <div className="hmg-picker">
                {BANNER_THEMES.map((item) => (
                  <button
                    key={item.value}
                    type="button"
                    title={t(item.label)}
                    className={`hmg-picker__grad ${form.theme === item.value ? "is-on" : ""}`}
                    style={{ background: item.value }}
                    onClick={() => this.setForm({ theme: item.value })}
                  />
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.SaveBanner}>
            <span className="icon text-12">{ADMIN_ICON.check}</span>
            {t("confirm")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { updated_at, updated_by, list_open } = this.state;

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("home_banner_manage")}</h3>
              <div className="text-secondary text-14">{t("home_banner_manage_desc")}</div>
            </div>
            <div className="text-secondary text-12 text-lg-end">
              <div>
                {t("updated")} {format_date(updated_at, "dd mmm yyyy hh:mm", locale())}
              </div>
              <div>
                {t("updated_by")} {updated_by}
              </div>
            </div>
          </div>

          {/* ย่อแล้วรายการหดเป็นแถบแคบชิดซ้าย ที่เหลือเป็นของกล่องตัวอย่างเว็บทางขวา */}
          <div className="row g-3">
            <div className={list_open ? "col-xl-7 col-lg-7" : "col-auto"}>{list_open ? this.renderList() : this.renderRail()}</div>
            <div className={list_open ? "col-xl-5 col-lg-5" : "col"}>{this.renderPreview()}</div>
          </div>
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}
